export const api = {
    room: (roomId: string) => `/api/rooms/${roomId}/`,
    rooms: () => '/api/rooms/',
    adminPortalRooms: () => '/api/adminportal/rooms/',
    flags: () => '/accounts/feature_flipper/',
    permissionSets: (roomId: string) => `/api/rooms/${roomId}/permission-set-choices/`
};
